var map = {
	"./de_DE.json": [
		27634,
		634
	],
	"./en_GB.json": [
		99476,
		476
	],
	"./en_US.json": [
		62653,
		653
	],
	"./es_ES.json": [
		15236,
		236
	],
	"./fr_FR.json": [
		43388,
		388
	],
	"./it_IT.json": [
		80542,
		542
	],
	"./ja_JP.json": [
		36553,
		553
	],
	"./ko_KR.json": [
		40931,
		931
	],
	"./pt_BR.json": [
		37536,
		536
	],
	"./zh_CN.json": [
		65507,
		507
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38522;
module.exports = webpackAsyncContext;